import { Check } from "lucide-react";

const bullets = [
  "Certified professional arborist — 10+ years in the field",
  "Fully insured, licensed & equipped for storm work",
  "Brevard County local — fast response, real accountability",
  "No job too big or too small — one call handles it all",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#EAE6DF]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 relative">
          <div
            className="aspect-[4/5] bg-cover bg-center border-2 border-[#0B1810]"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1699391414255-3a10698f8d50?auto=format&fit=crop&w=1400&q=80')",
            }}
          />
          <div className="absolute -bottom-6 -right-6 bg-[#FF5A00] text-white p-6 max-w-[260px] shadow-[8px_8px_0_#0B1810]">
            <div className="font-heading text-6xl leading-none">10+</div>
            <div className="font-accent text-xs tracking-[0.2em] uppercase mt-2">
              Years serving Brevard County
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="overline mb-4">Meet Ben</div>
          <h2 className="h-section text-[#0B1810] mb-6">
            A Decade
            <br />
            Under the <span className="text-[#FF5A00]">Canopy.</span>
          </h2>
          <p className="text-lg text-[#4A4D4A] font-body leading-relaxed mb-5">
            I'm Ben — owner and lead arborist at Hurricane Cuts. For over ten
            years I've served Brevard County, Florida as a professional tree
            man, from expert trimming and safe removals to full stump grinding,
            landscaping and pool builds — working yards from Rockledge and
            Melbourne to Cocoa, Cocoa Beach, Merritt Island, Cape Canaveral,
            Titusville and Viera.
          </p>
          <p className="text-lg text-[#4A4D4A] font-body leading-relaxed mb-8">
            At Hurricane Cuts, no job is too big or too small. Whether you're
            in Rockledge, Cocoa Beach or anywhere else in Brevard County — one
            call, and we'll take care of everything.
          </p>

          <ul className="space-y-3 mb-8">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <span className="w-6 h-6 bg-[#FF5A00] flex items-center justify-center flex-shrink-0 mt-1">
                  <Check size={14} className="text-white" strokeWidth={3} />
                </span>
                <span className="text-[#1A1A1A] font-body">{b}</span>
              </li>
            ))}
          </ul>

          <a href="#contact" className="btn-primary">
            Get a Free Quote
          </a>
        </div>
      </div>
    </section>
  );
}
